"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_uid_1 = require("react-uid");
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var FieldContext_1 = require("./FieldContext");
exports.useId = function (id) {
    var fieldId = FieldContext_1.useFieldContext().id;
    var genId = react_uid_1.useUID();
    return fallback_1.default(id, fieldId
        ? fieldId + "-" + genId
        : genId);
};
exports.useFieldAria = function (_a) {
    var _b = _a === void 0 ? {} : _a, ariaLabelledBy = _b["aria-labelledby"], ariaDescribedBy = _b["aria-describedby"], ariaInvalid = _b["aria-invalid"], ariaRequired = _b["aria-required"];
    var _c = FieldContext_1.useFieldContext(), invalid = _c.invalid, required = _c.required, labelId = _c.labelId, messageId = _c.messageId, isGroup = _c.isGroup;
    var ariaAttrs = {};
    ariaAttrs['aria-invalid'] = fallback_1.default(ariaInvalid, invalid || undefined);
    ariaAttrs['aria-required'] = fallback_1.default(ariaRequired, required || undefined);
    ariaAttrs['aria-labelledby'] = [ariaLabelledBy, !isGroup && labelId].filter(Boolean).join(' ');
    ariaAttrs['aria-describedby'] = [ariaDescribedBy, !isGroup && messageId].filter(Boolean).join(' ');
    return pickBy_1.default(ariaAttrs, Boolean);
};
